'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinWaitlist = exports.CODE_BY_ERROR = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

exports.doJoinWaitlist = doJoinWaitlist;
exports.watchLeadGenFormSagas = watchLeadGenFormSagas;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _deep = require('helpers/deep');

var _multitrack = require('helpers/multitrack');

var _optimizely = require('helpers/optimizely');

var _userTypeCookie = require('helpers/userTypeCookie');

var _utmValues = require('helpers/utmValues');

var utmValues = _interopRequireWildcard(_utmValues);

var _bound = require('redux/saga/entities/bound');

var _cms = require('redux/saga/selectors/cms');

var _location = require('redux/saga/helpers/location');

var _homepage = require('redux/modules/features/homepage');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doJoinWaitlist),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchLeadGenFormSagas);

var CODE_BY_ERROR = exports.CODE_BY_ERROR = (0, _freeze2.default)({
  ALREADY_MEMBER: 4405,
  ALREADY_ON_WAITLIST: 4401,
  INVALID_EMAIL: 4402
});

var LEAD_GEN_JOIN_WAITLIST = 'LEAD_GEN_JOIN_WAITLIST';
var joinWaitlist = exports.joinWaitlist = function joinWaitlist(_ref) {
  var email = _ref.email,
      location = _ref.location,
      submissionType = _ref.submissionType;
  return {
    type: LEAD_GEN_JOIN_WAITLIST,
    email: email,
    location: location,
    submissionType: submissionType
  };
};

function doJoinWaitlist(client, _ref2) {
  var email = _ref2.email,
      _ref2$location = _ref2.location,
      lat = _ref2$location.lat,
      lon = _ref2$location.lon,
      submissionType = _ref2.submissionType;

  var _ref3, _ref4, conversionData, location, msaId, path, errorCode, _path;

  return _regenerator2.default.wrap(function doJoinWaitlist$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.all)([(0, _effects.call)(utmValues.getForApi), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.glsLocation, [client, lat, lon])]);

        case 3:
          _ref3 = _context.sent;
          _ref4 = (0, _slicedToArray3.default)(_ref3, 2);
          conversionData = _ref4[0];
          location = _ref4[1];
          msaId = (0, _deep.deepExtract)('msa.id', location);
          _context.next = 10;
          return (0, _effects.call)(_sagaTools.fetchEntity, _bound.waitlistRequest, [client, {
            conversion: conversionData,
            country_code: (0, _deep.deepExtract)('msa.country.code', location),
            email: email,
            gls_location_id: location.location.id,
            msa_id: msaId,
            submission_type: submissionType
          }]);

        case 10:
          _context.next = 12;
          return (0, _effects.select)(_cms.selectCmsPath);

        case 12:
          path = _context.sent;
          _context.next = 15;
          return (0, _effects.all)([(0, _effects.call)(_userTypeCookie.set, 'lead'), (0, _effects.spawn)(_multitrack.ga, 'Lead Submission', 'successful_submission', path, 1), (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'lead_capture'), (0, _effects.call)(_location.persistUserLocation, lat, lon), (0, _effects.put)((0, _homepage.setMsaId)(msaId))]);

        case 15:
          _context.next = 40;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context['catch'](0);
          errorCode = (0, _deep.deepExtract)('code', _context.t0);
          _context.next = 22;
          return (0, _effects.select)(_cms.selectCmsPath);

        case 22:
          _path = _context.sent;

          if (!(CODE_BY_ERROR.ALREADY_ON_WAITLIST === errorCode)) {
            _context.next = 30;
            break;
          }

          _context.next = 26;
          return (0, _effects.call)(_userTypeCookie.set, 'lead');

        case 26:
          _context.next = 28;
          return (0, _effects.spawn)(_multitrack.ga, 'Lead Submission', 'duplicate_lead_error', _path, 1);

        case 28:
          _context.next = 40;
          break;

        case 30:
          if (!(CODE_BY_ERROR.ALREADY_MEMBER === errorCode)) {
            _context.next = 37;
            break;
          }

          _context.next = 33;
          return (0, _effects.call)(_userTypeCookie.set, 'registered');

        case 33:
          _context.next = 35;
          return (0, _effects.spawn)(_multitrack.ga, 'Lead Submission', 'email_associated_account_error', _path, 1);

        case 35:
          _context.next = 40;
          break;

        case 37:
          if (!(CODE_BY_ERROR.INVALID_EMAIL === errorCode)) {
            _context.next = 40;
            break;
          }

          _context.next = 40;
          return (0, _effects.spawn)(_multitrack.ga, 'Lead Submission', 'invalid_email_error', _path, 1);

        case 40:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 17]]);
}

function watchLeadGenFormSagas(client) {
  return _regenerator2.default.wrap(function watchLeadGenFormSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LEAD_GEN_JOIN_WAITLIST, doJoinWaitlist, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}